<script>	
	import DataLayer from './components/DataLayer.svelte';
	import Map from './components/Map.svelte';
	import Traces from './components/Traces.svelte';
</script>

<DataLayer let:key={dataKey}>
	<div class='row'>
		<Map {dataKey} />
		<Traces {dataKey} />
	</div>
</DataLayer>


<style>
:global(.row) {	
	display: flex;
	flex-direction: row;
}
:global(.col) {
	display: flex;
	flex-direction: column;
}
:global(.card) {
	margin: 5px;
	padding: 5px;
	border-radius: 5px;
	border-style: solid;
	border-color: #ddd;
	border-width: 1px;
}
:global(.no-select) {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
.left-side {
	flex-grow: 0;
	width: 377px;
}
</style>
